export const Vendors = {
  ga: 'GA',
  mixpanel: 'mixpanel',
  moEngage: 'moEngage',
} as const;

export const Events = {
  pageView: 'page_view',
  buttonClick: 'button_click',
  formSubmit: 'form_submit',
} as const;
